import React from "react";
import { Form, Input, Row, Col, Checkbox, InputNumber } from "antd";
import { phoneValidator, emailValidator } from "../../../../utils/validator";

const { TextArea } = Input;

const ContactInformationSection = () => {
  return (
    <div className="p-5">
      <Row gutter={[16, 16]}>
        <Col span={7} xs={24} md={12} lg={7}>
          <Form.Item
            name="phone"
            label="Phone"
            rules={[
              {
                validator: phoneValidator,
              },
            ]}
          >
            <Input placeholder="Phone Number" maxLength={20} />
          </Form.Item>
        </Col>
        <Col span={7} xs={24} md={12} lg={7}>
          <Form.Item
            name="email"
            label="Email"
            rules={[{ validator: emailValidator }]}
          >
            <Input placeholder="Email Address" maxLength={60} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={7} xs={24} md={12} lg={7}>
          <Form.Item name="decline_phone_number">
            <Checkbox>Patient declines to provide</Checkbox>
          </Form.Item>
        </Col>
        <Col span={7} xs={24} md={12} lg={7}>
          <Form.Item name="decline_email">
            <Checkbox>Patient declines to provide</Checkbox>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 16]} className="mt-[-1rem] mr-0">
        <Col span={6} xs={24} md={10} lg={6}>
          <Form.Item
            name="home"
            label="Home"
            rules={[
              {
                validator: phoneValidator,
              },
            ]}
          >
            <Input placeholder="Phone" maxLength={20} />
          </Form.Item>
        </Col>
        <Col span={6} xs={16} md={10} lg={6}>
          <Form.Item
            name="work"
            label="Work"
            rules={[
              {
                validator: phoneValidator,
              },
            ]}
          >
            <Input placeholder="Work" maxLength={20} />
          </Form.Item>
        </Col>
        <Col span={2} xs={4} md={4} lg={2}>
          <Form.Item name="extension" label="Extension">
            <InputNumber
              placeholder="Ext."
              maxLength={5}
              type="number"
            />
          </Form.Item>
        </Col>
      </Row>
      
      <Row gutter={16}>
        <Col span={14} xs={24} md={24} lg={14}>
          <Form.Item name="patient_contact_info_notes" label="Notes">
            <TextArea showCount maxLength={300} />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default React.memo(ContactInformationSection);
